export function defaultExerciseProgress(exerciseId) {
    return {
        exerciseId, passed: false, grade: 0, played: 0, records: []
    };
}
export function practiceResult(grade) {
    const passed = grade >= 0.7;
    return { grade, passed };
}
export function exerciseProgressWithRecord(progress, record) {
    const { grade: recordGrade, passed } = practiceResult(record.evaluation.grade);
    const grade = Math.max(progress.grade, recordGrade);
    return {
        exerciseId: progress.exerciseId,
        played: progress.played + 1,
        grade, passed,
        records: [...progress.records, record]
    };
}
//# sourceMappingURL=ExerciseProgress.js.map